import { Form, Row, Col, FormGroup, Label, Input, Button, Modal, ModalHeader, ModalBody, ModalFooter, Breadcrumb, BreadcrumbItem, Container } from 'reactstrap';
import React, { useState, useRef, Component } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import ContenedoresSemanalesTable from "../ContenedoresSemanales/ContenedoresSemanalesTable"
import { ContenedoresSemanalesView } from "./ContenedoresSemanalesView"
import { ContenedoresSemanalesDelete } from "./ContenedoresSemanalesDelete"
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';
import CleaningServicesOutlinedIcon from '@mui/icons-material/CleaningServicesOutlined';
import CachedOutlinedIcon from '@mui/icons-material/CachedOutlined';

import authService from '../api-authorization/AuthorizeService'
import { Breadcrumbs } from '../General/Breadcrumbs';
import { BLsView } from './BLsView'

export class ContenedoresSemanales_Index extends Component {
    static displayName = ContenedoresSemanales_Index.name;
    constructor(props) {
        super(props);
        
        this.state = {
            data: [],
            loading: true,
            modalState: false,
            modalHeader: "Cargando",
            modalBody: () => { return (<div>Cargando</div>); },
            modalOperation: 'add',
            modalIsValid: false,
            modalBLsState: false,
            model: { etiquetaEspecial: "", destino_Id: 0, contenedor_Id: 0, contenedor: "" },
            vaporSemanal: {},
            destinos: [],
            contenedores: []
        };
        this.load_vaporSemanal = this.load_vaporSemanal.bind(this);
        this.load_destinos = this.load_destinos.bind(this);
        this.load_contenedores = this.load_contenedores.bind(this);
        this.populateData = this.populateData.bind(this);
        this.modalBodyState = {};
        this.modalToggle = this.modalToggle.bind(this);
        this.modalBLsToggle = this.modalBLsToggle.bind(this);
        this.add_onclick = this.add_onclick.bind(this);
        this.add_modal_guardar_onclick = this.add_modal_guardar_onclick.bind(this);
        this.edit_onclick = this.edit_onclick.bind(this);
        this.edit_modal_guardar_onclick = this.edit_modal_guardar_onclick.bind(this);
        this.delete_onclick = this.delete_onclick.bind(this);
        this.delete_modal_guardar_onclick = this.delete_modal_guardar_onclick.bind(this);
        this.setModalBodyState = this.setModalBodyState.bind(this);
        this.modalSubmit = this.modalSubmit.bind(this);
        this.handleSearchChange = this.handleSearchChange.bind(this);
        this.clean_onclick = this.clean_onclick.bind(this);
    }

    componentDidMount() {
        this.populateData();
    }

    modalToggle() {
        this.setState({
            modalState: !this.state.modalState
        });
    }
    modalBLsToggle() {
        console.log("modalBLsState",this.state.modalBLsState)
        this.setState({
            modalBLsState: !this.state.modalBLsState
        });
    }

    renderTable() {
        return (
            <div  >
                <Row>
                    <Form >
                        <Row>
                            <Col md="3">
                                <FormGroup>
                                    <Label for="destino_Id">
                                        <FormattedMessage id='Destino' />
                                    </Label>
                                    <Input
                                        id="destino_Id"
                                        name="destino_Id"
                                        type="select"
                                        onChange={this.handleSearchChange}
                                    >
                                        <option value="0"></option>
                                        {this.state.destinos.map(destino => destino.destino_Id == this.state.model.destino_Id ? (
                                            <option value={destino.destino_Id} selected>
                                                {destino.nombre}
                                            </option>
                                        ) : (<option value={destino.destino_Id}>{destino.nombre}</option>))}
                                    </Input>
                                </FormGroup>
                            </Col>
                            {/*<Col md="3">*/}
                            {/*    <FormGroup>*/}
                            {/*        <Label for="contenedor_Id">*/}
                            {/*            <FormattedMessage id='Contenedor' />*/}
                            {/*        </Label>*/}
                            {/*        <Input*/}
                            {/*            id="contenedor_Id"*/}
                            {/*            name="contenedor_Id"*/}
                            {/*            type="select"*/}
                            {/*            onChange={this.handleSearchChange}*/}
                            {/*        >*/}
                            {/*            <option value="0"></option>*/}
                            {/*            {this.state.contenedores.map(contenedor => contenedor.contenedor_Id == this.state.model.contenedor_Id ? (*/}
                            {/*                <option value={contenedor.contenedor_Id} selected>*/}
                            {/*                    {contenedor.contenedor}*/}
                            {/*                </option>*/}
                            {/*            ) : (<option value={contenedor.contenedor_Id}>{contenedor.contenedor}</option>))}*/}
                            {/*        </Input>*/}
                            {/*    </FormGroup>*/}
                            {/*</Col>*/}
                            <Col md="3">
                                <FormGroup>
                                    <Label for="contenedor">
                                        <FormattedMessage id='Contenedor' />
                                    </Label>
                                    <FormattedMessage id='Contenedor'>
                                        {(placeholder) =>
                                            <Input
                                                id="contenedor"
                                                name="contenedor"
                                                //placeholder={placeholder}
                                                type="text"
                                                onChange={this.handleSearchChange}
                                                value={this.state.model.contenedor}
                                            />
                                        }
                                    </FormattedMessage>
                                </FormGroup>
                            </Col>
                            <Col md="3">
                                <FormGroup>
                                    <Label for="searchEtiquetaEspecial">
                                        <FormattedMessage id='EtiquetaEspecial' />
                                    </Label>
                                    <FormattedMessage id='EtiquetaEspecial'>
                                        {(placeholder) =>
                                            <Input
                                                id="searchEtiquetaEspecial"
                                                name="etiquetaEspecial"
                                                //placeholder={placeholder}
                                                type="text"
                                                onChange={this.handleSearchChange}
                                                value={this.state.model.etiquetaEspecial}
                                            />
                                        }
                                    </FormattedMessage>

                                </FormGroup>
                            </Col>
                            <Col className="col-auto">
                                <FormGroup>
                                    <IconButton size='small' className='SearchButton IndexButton' onClick={this.populateData}>
                                        <SearchIcon />
                                    </IconButton>
                                </FormGroup>
                            </Col>
                            <Col className="col-auto">
                                <FormGroup>
                                    <Button className="CleanButton IndexButton" onClick={this.clean_onclick}>
                                        <CachedOutlinedIcon fontSize='large' /> <FormattedMessage id='Limpiar' />
                                    </Button>
                                </FormGroup>
                            </Col>
                        </Row>
                    </Form>
                </Row>
                <Row>
                    <ContenedoresSemanalesTable data={this.state.data}
                        add_onclick={this.add_onclick} edit_onclick={this.edit_onclick} delete_onclick={this.delete_onclick}
                        addBLs_onclick={this.modalBLsToggle} />
                </Row>
                <Modal isOpen={this.state.modalState} toggle={this.modalToggle}>
                    <ModalHeader toggle={this.modalToggle}>
                        {this.state.modalHeader}
                    </ModalHeader>
                    <ModalBody>
                        {this.state.modalBody}
                    </ModalBody>
                    <ModalFooter>
                        <Button color="primary" onClick={this.modalSubmit} disabled={!this.state.modalIsValid}>
                            {this.state.modalOperation == 'delete' ? <FormattedMessage id='Eliminar' /> : <FormattedMessage id='Guardar' />}
                        </Button>{' '}
                        <Button color="secondary" onClick={this.modalToggle}>
                            Cancelar
                        </Button>
                    </ModalFooter>
                </Modal>
                <BLsView operation='add' modalState={this.state.modalBLsState} callback={this.populateData} toggleCallback={this.modalBLsToggle}></BLsView>
            </div>
        );
    }

    render() {
        let breadcrumbsData = this.state.loading
            ? <p></p>
            : <Breadcrumbs data={[
                { link: "/Semanas", message: "Semanas", active: true },
                { link: "/Semanas/" + this.state.vaporSemanal.semana_Id + "/VaporesSemanalesProveedor", message: "Vapores", active: true },
                { link: "/VaporesSemanales/" + this.state.vaporSemanal.vaporSemanalProveedor_Id + "/ContenedoresSemanales", message: "Contenedores Semanales", active: false },
            ]} />;
        console.log("render this.state.modalBLsState", this.state.modalBLsState);
        let contents = this.state.loading
            ? <p><em>Cargando...</em></p>
            : this.renderTable();

        return (
            <div style={{ width: '100%' }}>
                <h2><FormattedMessage id='Contenedores Semanales' /></h2>
                {breadcrumbsData}
                
                <div className="viewContainerHeader ">
                    <div className="d-flex justify-content-start">
                        <div className="px-4 py-2"><FormattedMessage id='Semana' />: {this.state.vaporSemanal.semana}</div>
                        {/*<div className="px-4 py-2"><FormattedMessage id='Barco' />: {this.state.contenedorSemanal.barco}</div>*/}
                    </div>
                    <div className="d-flex justify-content-start">
                        <div className="px-4 py-2"><FormattedMessage id='Naviera' />: {this.state.vaporSemanal.naviera}</div>
                        <div className="px-4 py-2"><FormattedMessage id='Barco' />: {this.state.vaporSemanal.barco}</div>
                        <div className="px-4 py-2"><FormattedMessage id='Viaje' />: {this.state.vaporSemanal.viaje}</div>
                        {/*<div className="px-4 py-2"><FormattedMessage id='Contenedor' />: {this.state.contenedorSemanal.contenedor}</div>*/}
                        {/*<div className="px-4 py-2"><FormattedMessage id='EtiquetaEspecial' />: {this.state.contenedorSemanal.etiquetaEspecial}</div>*/}
                    </div>
                </div>
                <div className="viewContainer-lg">
                    {contents}
                </div>

            </div>
        );
    }

    async populateData() {
        this.setState({ loading: true, vaporSemanal: await this.load_vaporSemanal(), destinos: await this.load_destinos() }, async () => {
            this.setState({ contenedores: [] }, async () => {
                const token = await authService.getAccessToken();
                var queryString = '?vaporSemanalProveedor_Id=' + this.state.vaporSemanal.vaporSemanalProveedor_Id + '&';
                Object.keys(this.state.model).forEach(key => {
                    queryString += key + "=" + this.state.model[key] + "&";
                });
                queryString = queryString.slice(0, -1);
                const response = await fetch('api/contenedoresSemanales' + queryString, {
                    headers: !token ? {} : { 'Authorization': `Bearer ${token}` },
                });
                const responceData = await response.json();
                this.setState({ data: responceData, loading: false });
            });
        });
    }

    async handleSearchChange(event) {
        event.preventDefault();
        var model = this.state.model;
        model[event.target.name] = event.target.value;
        this.setState({ model: model }, async () => {
            
        });

    }
    async modalSubmit(id) {
        if (this.state.modalOperation == 'add') {
            this.add_modal_guardar_onclick();
        }
        else if (this.state.modalOperation == 'edit') {
            this.edit_modal_guardar_onclick(id);
        }
        else if (this.state.modalOperation == 'delete') {
            this.delete_modal_guardar_onclick(id);
        }
    }
    async add_onclick() {
        this.setState({
            modalHeader: this.add_modal_header(),
            modalBody: this.add_modal_body(),
            modalState: true,
            modalOperation: 'add',
        });
    }
    add_modal_header() {
        return (<div><FormattedMessage id='Nuevo' /></div>);
    }
    add_modal_body() {
        return (<div><ContenedoresSemanalesView operation={this.state.modalOperation} setModalBodyState={this.setModalBodyState}></ContenedoresSemanalesView></div>);
    }
    async add_modal_guardar_onclick() {
        const token = await authService.getAccessToken();
        const data = JSON.stringify(this.modalBodyState);
        const response = await fetch('api/contenedoresSemanales', {
            method: 'POST',
            headers: !token ? {} : { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
            body: data
        });
        if (response.ok) {
            this.modalToggle();
            await this.populateData()
        }
        //const responceData = await response.json();
    }
    async edit_onclick(id) {
        const modalBody = await this.edit_modal_body(id);
        this.setState({
            modalHeader: this.edit_modal_header(id),
            modalBody: modalBody,
            modalState: true,
            modalOperation: 'edit',
        });
    }
    edit_modal_header(id) {
        return (<div><FormattedMessage id='Editar' /></div>);
    }
    async edit_modal_body(id) {
        const token = await authService.getAccessToken();
        const response = await fetch('api/contenedoresSemanales/' + id, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        const responceData = await response.json();
        return (<div><ContenedoresSemanalesView operation={ this.state.modalOperation} setModalBodyState={this.setModalBodyState} data={responceData}></ContenedoresSemanalesView></div>);
        //return (<div><ContenedoresSemanalesView ref={this.modalBodyState}></ContenedoresSemanalesView></div>);
    }
    async edit_modal_guardar_onclick() {
        const token = await authService.getAccessToken();
        const data = JSON.stringify(this.modalBodyState);
        const response = await fetch('api/contenedoresSemanales/' + this.modalBodyState.contenedorSemanal_Id, {
            method: 'PUT',
            headers: !token ? {} : { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
            body: data
        });
        if (response.ok) {
            this.modalToggle();
            await this.populateData()
        }
    }
    async delete_onclick(id) {
        const modalBody = await this.delete_modal_body(id);
        this.setState({
            modalHeader: this.delete_modal_header(id),
            modalBody: modalBody,
            modalState: true,
            modalOperation: 'delete',
            modalIsValid: true
        });
    }
    delete_modal_header(id) {
        return (<div><FormattedMessage id='Eliminar' /></div>);
    }
    async delete_modal_body(id) {
        const token = await authService.getAccessToken();
        const response = await fetch('api/contenedoresSemanales/' + id, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        const responceData = await response.json();
        await this.setModalBodyState({ model: responceData });
        return (<div><ContenedoresSemanalesDelete setModalBodyState={this.setModalBodyState} data={responceData}></ContenedoresSemanalesDelete></div>);
    }
    async delete_modal_guardar_onclick() {
        const token = await authService.getAccessToken();
        const response = await fetch('api/contenedoresSemanales/' + this.modalBodyState.contenedorSemanal_Id, {
            method: 'DELETE',
            headers: !token ? {} : { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
        });
        if (response.ok) {
            this.modalToggle();
            await this.populateData()
        }
    }
    async clean_onclick() {
        this.setState({
            model: { etiquetaEspecial: "" }
        });
        await this.populateData()
    }

    async setModalBodyState(state) {
        this.modalBodyState = state.model;
        if (state.modelValidation) {
            console.log("state.modelValidation",state.modelValidation)
            var modalIsValid = !Object.keys(state.modelValidation).some(function (val) {
                return state.modelValidation[val] == false;
            });
            this.setState({
                modalIsValid: modalIsValid
            });
        }

    }
    async load_vaporSemanal() {
        var rawUrl = window.location.toString();
        var vaporSemanalProveedor_Id = rawUrl.split("VaporesSemanales/")[1].split("/")[0];
        const token = await authService.getAccessToken();
        const response = await fetch('api/vaporesSemanalesProveedor/' + vaporSemanalProveedor_Id, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        return await response.json();
    }
    async load_destinos() {
        const token = await authService.getAccessToken();
        const response = await fetch('api/destinos/', {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        return await response.json();
    }
    async load_contenedores() {
        const token = await authService.getAccessToken();
        const response = await fetch('api/contenedoresSemanales?vaporSemanalProveedor_Id=' + this.state.vaporSemanal.vaporSemanalProveedor_Id, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        return await response.json();
    }

}